/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { InviteUserProps } from "./components";

const is = require("is_js");

const SERVICE_NAME = "UsersListPageService";
const log: any = LoggerModule.getInstance();

export class UsersListPageService {
  private static instance: UsersListPageService;
  private vapp: VApplication;
  private loginRestAPI: string;
  private criteria: any;
  private headers: any;
  private token: string;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
    this.token = props?.token;
  }

  public static getInstance(props: any = {}): UsersListPageService {
    if (!UsersListPageService.instance) {
      UsersListPageService.instance = new UsersListPageService(props);
    }
    return UsersListPageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPageContent(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.criteria) {
      this.setCriteria(args?.criteria);
    }

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Get user role Props
    compProps = await agent.getSupportedRolesProps({});

    if (compProps) {
      content = { ...content, ...compProps };
    }
    
    //UserLists Props
    compProps = await agent.getUserListsProps({
      ...args,
      criteria: { ...this.criteria, ...args?.criteria },
    });
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async inviteUser(args: InviteUserProps) {
    log.info(`invite user`, args);
    let compProps: any = null;
    let details: any = args;
    const agent = getAgent();
    // TODO QUICK FIXS NEED TO BE REMOVED THIS IS TEMPORARY FIX
    // const roleIdToAdd = "fe93dab0-424b-4aa3-9efa-c001b4c04444";
    // if (!args.role.includes(roleIdToAdd)) {
    //     args.role.push(roleIdToAdd);
    // }
    for (const roleId of args.role) {
      const details = {
        ...args, // Spread the existing properties of roleArray
        role: roleId // Update the roleId property
      };
      compProps = await agent.getInviteUser(details);
    }
    return compProps;
  }

  public async deleteUser(args: any) {
    const agent = getAgent();
    return agent.getDeleteUser(args);
  }

  public async suspendUser(args: any) {
    log.info(`suspend  user service`, args);
    const agent = getAgent();
    return agent.getSuspendUser(args);
  }

  public async activateUser(args: any) {
    log.info(`activate  user service`, args);
    const agent = getAgent();
    return agent.getActivateUser(args);
  }

  public async reInviteUser(args: any) {
    log.info(`reset user service`, args);
    const agent = getAgent();
    return agent.getReInviteUser(args);
  }

  // TODO QUICK FIXS NEED TO BE REMOVED THIS IS TEMPORARY FIX
  private checkRole( roleId : string) {
    const roleArray = [
      {
        "label": "Masquerader",
        "id": "fe93dab0-424b-4aa3-9efa-c001b4c04444"
      },
      {
          "label": "Admin",
          "id": "fe93dab0-424b-4aa3-9efa-c001b4c03013"
      },
      {
          "label": "committeMember",
          "id": "99403c8b-abc1-4796-b61f-78e0c4022792"
      },
      {
          "label": "cashier",
          "id": "f5bebfee-dc0a-460a-9a3f-c6cde8fed944"
      }
    ];
    const matchedRole = roleArray.find((r) => r.id === roleId);
    if (matchedRole && (matchedRole.label === "Admin" || matchedRole.label === "committeMember" || matchedRole.label === "cashier")) {
      return true;
    }
    return false;
  }
}
